module.exports = __webpack_public_path__ + "img/J12869.a051c980.png";